import { Link } from 'react-router-dom';
import DonationHistory from '../Admin/DonorManagement/DonationHistory'
import TokenService from '../../Services/Token.service';
import DonorChoosenSample from '../../Components/AdministrativeSettings/DonorManagement/DonatorChoosenSample';
import DonationProgress from '../../Components/AdministrativeSettings/DonorManagement/DonationProgressbar';
import { useEffect, useState } from 'react';
import { AdminService } from '../../Services/Admin.service';
import { DonorService } from '../../Services/Donor.Service';
import { SampleService } from '../../Services/Sample.service';
import { Helmet } from "react-helmet";

function DonationHistoryDonor() {
    const [sampleTypes, setSampleTypes] = useState(); 
    const [donorData, setDonorData] = useState();
    useEffect(() => {
        const fetchUserDetails = async (userId) => {
            try {
                const userDetails = await DonorService.getDonorDetails(userId);        
                setDonorData(userDetails.data.user);
            } catch (error) {
                console.error("Failed to fetch user details", error);
            }
        };
        fetchUserDetails(TokenService.getUserId());

        async function fetchSampleTypes() {
            const result = await AdminService.getSampleTypes();
            setSampleTypes(result || []);
        }
        fetchSampleTypes();
    }, []);
    return (
        <>
            <Helmet>
                <title>DonorX | Donation History</title>
            </Helmet>
            <div className="el-middle-wrapper">
                <h2 className="el-title">Donation History</h2>

                <div className={`el-profile-board   el-bg-table mb-5`}>
                    <div className="el-card-content">
                        <div className="el-blood-donation-section">
                            <div className="row">
                                <DonorChoosenSample sampleTypes={sampleTypes} userData={donorData} userType ={"donor"} />
                                <DonationProgress totalLimit={500}  donationDone={donorData?.total_blood_donate  || 0} />
                            </div>
                        </div>
                        <div className="my-5 el-bg-table">
                            <DonationHistory   userType ={"donor"} />
                        </div>
                    </div>
                </div></div>
        </>
    );
}

export default DonationHistoryDonor;